import React from 'react';
import PropTypes from 'prop-types';
import PlatformReactMarkdown from 'lib/react-markdown';

const GroupIntro = ({ title, subtitle, paragraphs, buttonText, onNext, onBack }) => {
  return (
    <div className="intake-step text-center">
      <h1 className="intake-title">{title}</h1>
      <h2 className="intake-subtitle">{subtitle}</h2>
      {paragraphs && (
        <div className="intake-paragraphs">
          <PlatformReactMarkdown>{paragraphs.join('\n\n')}</PlatformReactMarkdown>
        </div>
      )}
      <div className="intake-actions">
        {onBack && (
          <button type="button" className="btn btn-light px-4" onClick={onBack}>
            Back
          </button>
        )}
        <button type="button" className="btn btn-lg btn-secondary px-4" onClick={onNext}>
          {buttonText}
        </button>
      </div>
    </div>
  );
};

GroupIntro.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  buttonText: PropTypes.string.isRequired,
  onNext: PropTypes.func.isRequired,
  onBack: PropTypes.func
};

export default GroupIntro;
